import axios from "axios";
import { BASE_API_URL } from "../utils/api-url";

export async function getCompanies(accessToken) {
  const result = await axios.get(`${BASE_API_URL}/companies/500/1`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return result.data;
}

export async function getCompanyById(accessToken, id) {
  const result = await axios.get(`${BASE_API_URL}/companies/${id}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return result.data;
}

export async function editCompanieValues(accessToken, data) {
  const result = await axios(`${BASE_API_URL}/companies`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data,
  });

  return result.data;
}

export async function createCompany(accessToken, data) {
  const result = await axios({
    method: "POST",
    url: `${BASE_API_URL}/companies`,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data,
  });

  return result;
}
